import ModalDeleteFilled from '../../../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteSellDeliveryNoteDraftProps extends ModalEditComponentProps { }

const ModalDeleteSellDeliveryNoteDraft: React.FC<ModalDeleteSellDeliveryNoteDraftProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/sell/sellDeliveryNote/deleteSellDeliveryNoteDraft',
        data: {
            id: allRowData?.header?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteDraftdeliveryNote', '¿Seguro que quieres eliminar este borrador de albarán?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteSellDeliveryNoteDraft